import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {
  MonEtablissementDetailDialogComponent
} from "../mon-etablissement-detail-dialog/mon-etablissement-detail-dialog.component";
import {FlagService} from "../../../../../shared/services/flag.service";
import {EtablissementData} from "../../../../../shared/utils/data/etablissments-data";
import {FlagType} from "../../../../../shared/utils/enums";
import {Establishment} from "../../../../../models/Establishment";

@Component({
  selector: 'app-mon-etablissement-general',
  templateUrl: './mon-etablissement-general.component.html',
  styleUrl: './mon-etablissement-general.component.scss'
})
export class MonEtablissementGeneralComponent {
  @Input() establishment: Establishment;
  @Output() refreshData = new EventEmitter<any>()
  constructor(private dialog: MatDialog,  private flag: FlagService) {
  }

  openDetailDialog() {
    const dialogRef = this.dialog.open(MonEtablissementDetailDialogComponent,
      {minWidth: '60vw', autoFocus: false, data: this.establishment});

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.flag.displayFlag(
          EtablissementData.monEtablissement.successEtablissementUpdate,
          FlagType.success ,
          2
        )
        this.refreshData.emit(true)
      }
    });
  }
}
